module.exports = __webpack_public_path__ + "img/6.6f9f6e53.jpeg";